import React from 'react';
import styled from 'styled-components';

export default styled(({ src, ...rest }) => <div {...rest} />)`
  align-self: top;
  justify-self: center;
  background: transparent url(${({ src }) => src}) no-repeat center center;
  width: 4.375rem;
  height: 4.375rem;
  background-size: cover;
`;
